import { render } from "./StatisticsPortalAverageVisitsTimeTabs.vue?vue&type=template&id=12332d5b&ts=true"
import script from "./StatisticsPortalAverageVisitsTimeTabs.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortalAverageVisitsTimeTabs.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__